@if (action(); as route) {
  <a
    [routerLink]="route.route"
    [queryParams]="route.queryParams"
    [class]="ctaClass()"
  >
    {{ "help.onboarding.journey.actions.go" | transloco }}
    <lucide-icon name="arrow-right" [size]="prominent() ? 16 : 14" />
  </a>
}
